import { Text } from '@fozito/common-ui';
import { Card } from 'antd';
import { IShopItem } from 'modules/auth/services/types/owner';
import styled from 'styled-components';
import PlaceHolderStore from '../Login/OverlayBG/bg-layer-1.png';

interface CardInfoProps {
  store: IShopItem;
  className?: string;
  onClick?: () => void;
}

const StyledCard = styled(Card)`
    width: 100%;
    cursor: pointer;
    border-radius: 16px;

    .ant-card-body {
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding: 16px;
      border-radius: 16px;
      border: none;
      background-color: #FFFFFF;
    }
    
    .ant-card-body::before, .ant-card-body::after {
      display: none;
    }

    .fzt-image {
      aspect-ratio: 1.84 / 1;
      width: 100%;
      height: auto;
      border-radius: 16px;
      object-fit: cover;
  }
`;

const CardInfo = ({ store, className, onClick }: CardInfoProps) => {
  return (
    <StyledCard className={className} onClick={onClick}>
      <img className='fzt-image' src={PlaceHolderStore} alt={store.shopName} />
      <div>
        <Text title_h5_24_semibold_caplock text_left color_text_5>{store.shopName}</Text>
        <Text content_content_1_16_regular text_left color_text_4>{store.address}, {store.city} {store.state} {store.zip}</Text>
      </div>
    </StyledCard>
  );
};

export default CardInfo;